export default "__VITE_ASSET__Dnc5DG$9__"